import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AppThunk} from "../store.ts";
import {AxiosError} from "axios";
import {transferCampaignService} from "../services/transfer-campaign-service.ts";
import {successToastify} from "../../utils/Utils.ts";
import {
    CampaignHistoryList,
    IPendingPublicationResponseData,
    ITransferCampaignResponseData,
    IUpdateTransferCampaignParams
} from "../models/TransferCampaignResponse.ts";
import {ICampaignHistoryParams} from "../models/CampaignResponse.ts";
import {showCustomErrorToast} from "../../utils/customErrorToast.tsx";

type  InitialStateType = {
    data: ITransferCampaignResponseData | null
    pendingPublications: IPendingPublicationResponseData[] | null
    history: CampaignHistoryList | null
    isLoading: boolean
};

const initialState: InitialStateType = {
    data: null,
    pendingPublications: null,
    history: null,
    isLoading: false
}

const slice = createSlice({
    name: "transferCampaign",
    initialState: initialState,
    reducers: {
        setInitData: (state: InitialStateType, action: PayloadAction<ITransferCampaignResponseData>) => {
            state.data = action.payload
        },
        setPendingPublication: (state: InitialStateType, action: PayloadAction<IPendingPublicationResponseData[]>) => {
            state.pendingPublications = action.payload
        },
        setHistoryList: (state: InitialStateType, action: PayloadAction<CampaignHistoryList>) => {
            state.history = action.payload
        },
        updateData: (state: InitialStateType, action: PayloadAction<ITransferCampaignResponseData>) => {
            state.data = action.payload
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});
export const transferCampaignReducer = slice.reducer;
export const transferCampaignActions = slice.actions;

export const getTransferCampaignsTC = (id: string): AppThunk<Promise<ITransferCampaignResponseData | void>> =>
    async (dispatch) => {
        dispatch(transferCampaignActions.setLoading(true));
        try {
            const res = await transferCampaignService.fetchTransferCampaign(id);
            dispatch(transferCampaignActions.setInitData(res.data))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center');
            throw err;
        } finally {
            dispatch(transferCampaignActions.setLoading(false));
        }
    };

export const getPendingPublicationsTC = (id: string): AppThunk<Promise<IPendingPublicationResponseData[] | void>> =>
    async (dispatch) => {
        dispatch(transferCampaignActions.setLoading(true));
        try {
            const res = await transferCampaignService.fetchPendingPublications(id);
            dispatch(transferCampaignActions.setPendingPublication(res.data))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center');
            throw err;
        } finally {
            dispatch(transferCampaignActions.setLoading(false));
        }
    };

export const getTransferHistoryTC = (channelId: string, params?: ICampaignHistoryParams): AppThunk<Promise<CampaignHistoryList | void>> =>
    async (dispatch) => {
        // dispatch(transferCampaignActions.setLoading(true));
        try {
            const res = await transferCampaignService.fetchTransferHistory(channelId, params);
            dispatch(transferCampaignActions.setHistoryList(res.data))
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(err.message, 'main', 'bottom-center');
            throw err;
        } finally {
            // dispatch(transferCampaignActions.setLoading(false));
        }
    };

export const updateCurrentTransferCampaignTC = (id: string, params: IUpdateTransferCampaignParams, successTitle:string, errorTitle:string): AppThunk<Promise<ITransferCampaignResponseData | void>> =>
    async (dispatch) => {
        try {
            const res = await transferCampaignService.updateTransferCampaign(id, params);
            dispatch(transferCampaignActions.updateData(res.data));
            successToastify(successTitle, 'bottom-center', 'main')
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(errorTitle, 'main', 'bottom-center')
            // handleResponseError(err)
            throw err;
        } finally {
            dispatch(transferCampaignActions.setLoading(false));
        }
    };

export const updateStatusCurrentTransferCampaignTC = (id: string, params: IUpdateTransferCampaignParams, successTitle:string, errorTitle:string): AppThunk<Promise<ITransferCampaignResponseData | void>> =>
    async (dispatch) => {
        try {
            const res = await transferCampaignService.updateTransferCampaign(id, params);
            dispatch(transferCampaignActions.updateData(res.data));
            successToastify(successTitle, 'bottom-center', 'main')
            return res.data
        } catch (err) {
            if (err instanceof AxiosError)
                showCustomErrorToast(errorTitle, 'launch_modal', 'top-center')
            // handleResponseError(err)
            throw err;
        } finally {
            dispatch(transferCampaignActions.setLoading(false));
        }
    };
